import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useJobStatut } from '../hooks/useBulletins';
import { JobProgressBar } from '../components/JobProgressBar';

export function JobSuiviPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const { data: job, isLoading } = useJobStatut(jobId ?? null);

  if (isLoading || !job) {
    return (
      <div className="p-6 flex items-center justify-center">
        <p className="text-content-subtle">Chargement du statut du job...</p>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold text-content mb-2">Suivi de la génération</h1>
      <p className="text-sm text-content-subtle mb-6">Job ID : <code className="bg-surface-overlay px-1 rounded">{jobId}</code></p>

      <div className="bg-surface rounded-lg border border-border p-6">
        <JobProgressBar job={job} />

        {job.statut === 'completed' && job.resultat && (
          <div className="mt-4 p-3 bg-success-light rounded border border-success">
            <p className="text-sm font-medium text-success">
              ✅ {job.resultat.traites} bulletin(s) générés sur {job.resultat.total}
            </p>
            {job.resultat.erreurs.length > 0 && (
              <p className="text-sm text-danger mt-1">{job.resultat.erreurs.length} erreur(s)</p>
            )}
          </div>
        )}

        {job.statut === 'failed' && (
          <div className="mt-4 p-3 bg-danger-light rounded border border-danger">
            <p className="text-sm text-danger">❌ {job.erreur ?? 'Erreur inconnue'}</p>
          </div>
        )}
      </div>

      <div className="mt-4 flex gap-3">
        <Link to="/paie/bulletins" className="text-accent text-sm hover:underline">
          ← Retour à la liste
        </Link>
      </div>
    </div>
  );
}
